import { makeStyles, styled } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: "4px",
    gap: "4px",
  },
  tooltip: {
    backgroundColor: "black !important",
  },
  arrow: {
    color: "black !important",
  },
}));
